import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-09-19
 * @brief SEI Management - 사용자 관리 개발
 *
 ********************************************************************/
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import UserCommView from "./UserCommView";
import UserTree from "./UserTree";
import UserView from "./UserView";
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
export default function UserMain() {
    //props
    const { handleOpenPop } = useOutletContext();
    // tree 선택 시 이동
    const [selTree, setSelTree] = useState({
        company: { companyId: "", companyName: "" },
        reload: false,
    });
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx(UserTree, { selTree: selTree, setSelTree: setSelTree }), selTree.company.companyId && selTree.company.companyId == "SEI" ? (_jsx(UserCommView, { handleOpenPop: handleOpenPop })) : (_jsx(UserView, { handleOpenPop: handleOpenPop, selTree: selTree }))] })) }));
}
